import { animate, state, style, transition, trigger } from '@angular/animations';

export const sidenavContainerAnimation = trigger('sidenavContainerAnimation', [
  state('opened', style({ transform: 'none', visibility: 'visible' })),
  state('closed', style({ transform: 'translate3d(100%, 0, 0)', visibility: 'hidden' })),
  transition('opened <=> closed', animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
]);
